export default __webpack_public_path__ + "static/media/nurse2.7430810b.jpeg";